const buyerAlertBaseUrl = `${window.location.origin.replace('://', '://app.').replace('www.', '')}/alerte-achat/?source=site_listing`

const formatZonesForAlert = (zones) => {
  return zones.flatMap(zone => {
    if (zone.class === 'Quarter') {
      const parts = zone.displayedName.split(', ');
      return [parts.length > 1 ? parts[1] : zone.displayedName];
    } else {
      // Cas Paris 16e : "Paris 75016/75116" doit devenir 2 zones distinctes
      const match = zone.displayedName.match(/^(.*) (\d{5}(?:\/\d{5})+)$/);
      if (match) {
        const name = match[1];
        return match[2].split('/').map(zip => `${name} ${zip}`);
      }
      return [zone.displayedName];
    }
  });
}

export const buyerAlertUrl = (filters) => {
  const {
    zones,
    type: { apartment, house },
    surface: { min_area },
    budget: { min_budget, max_budget },
    room: { min_room_number, min_bedroom_number }} = filters

  const formattedZones = formatZonesForAlert(zones);
  const params = `&zone=${JSON.stringify(formattedZones)}&apartment=${apartment}&house=${house}&min_area=${min_area}&min_budget=${min_budget.replace(/ /g, '')}&max_budget=${max_budget.replace(/ /g, '')}&min_room_number=${min_room_number}&min_bedroom_number=${min_bedroom_number}`;
  return `${buyerAlertBaseUrl}${params}`;
}
